import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, usePagination, ButtonModifier } from "../../../components";
import { ShowTableBankMasuk } from "../../../components/ShowTable";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, Pagination } from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilBankMasuk = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [noBukti, setNoBukti] = useState("");
  const [tglBankMasuk, setTglBankMasuk] = useState("");
  const [tglBankMasukDate, setTglBankMasukDate] = useState();
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");
  const [isPost, setIsPost] = useState("");
  const [jumlah, setJumlah] = useState("");

  const [bankMasuksChildData, setBankMasuksChildData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  // let isEditableAdmin =
  //   user.tipeUser === "ADMIN" &&
  //   tglBankMasukDate?.getFullYear() === today.getFullYear() &&
  //   tglBankMasukDate?.getMonth() === today.getMonth() &&
  //   tglBankMasukDate?.getDate() === today.getDate() &&
  //   isPost === false;
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const currentPosts = bankMasuksChildData.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const count = Math.ceil(bankMasuksChildData.length / PER_PAGE);
  const _DATA = usePagination(bankMasuksChildData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    getBankMasukById();
  }, []);

  const getBankMasukById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/bankMasuks/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoBukti(response.data.noBukti);
    setTglBankMasuk(response.data.tglBankMasuk);
    setTglBankMasukDate(new Date(response.data.tglBankMasuk));
    setKodeCOA(response.data.coa);
    setKeterangan(response.data.keterangan);
    setIsPost(response.data.isPost);
    setJumlah(response.data.jumlah);
    const response2 = await postRequest(
      `/bankMasuksChildByBankMasuk`,
      { bankMasukId: response.data.id },
      navigate,
      dispatch
    );
    setBankMasuksChildData(response2.data);
    setLoading(false);
  };

  const deleteBankMasuk = async (id) => {
    setLoading(true);
    try {
      await postRequest(`/deleteBankMasuk/${id}`, {}, navigate, dispatch);
      navigate("/daftarBankMasuk");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Finance</h3>
      <h5 style={{ fontWeight: 400 }}>Bank Masuk</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarBankMasuk")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={`/daftarBankMasuk/bankMasuk/${id}/tambahBankMasukChild`}
              editLink={`/daftarBankMasuk/bankMasuk/${id}/edit`}
              deleteUser={deleteBankMasuk}
              nameUser={noBukti}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>Bank Masuk</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Bukti :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noBukti} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Bank Masuk :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tglBankMasuk}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode COA :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={`${kodeCOA.kodeCOA} - ${kodeCOA.namaCOA}`}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jumlah :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={jumlah.toLocaleString("de-DE")}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableBankMasuk id={id} currentPosts={currentPosts} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={count}
          page={page}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilBankMasuk;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
